<template>
  <div class="reply-mailbox-nav-bar" v-loading="loading">
    <div class="title-box">
      <p class="title">站外邮件</p>
      <p class="set" @click="$router.push('/crm/off-site-mailbox')">设置</p>
    </div>
    <div class="switch-cell" @click="openTemplateModal">新建邮件</div>
    <div v-if="treeData.length" class="nav-email-box">
      <div v-for="(item, index) in treeData" :key="index" style="margin: 7px 0 0">
        <p @click="emailItemHandel(item, index)" style="cursor: pointer; padding: 0 12px">
          <span
            :class="['el-icon-caret-right', 'triangle', { 'triangle-activate': item.show }]"
          ></span>
          <span
            style="
              width: 115px;
              box-sizing: border-box;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              display: inline-block;
            "
            >{{ item.account }}</span
          >
        </p>
        <el-collapse-transition>
          <div v-show="item.show" class="item-box">
            <p
              style="cursor: pointer"
              :class="{
                'item-activate': avtiviteItem.index == index && avtiviteItem.type == 'From',
              }"
              @click="handleNodeClick({ type: 'From', emailId: item.emailId }, index)"
            >
              收件箱
              <font color="red" v-if="item.fromUnreadCount != '0'">（{{ item.fromUnreadCount }}）</font>
            </p>
            <p
              :class="{
                'item-activate': avtiviteItem.index == index && avtiviteItem.type == 'To',
              }"
              style="cursor: pointer"
              @click="handleNodeClick({ type: 'To', emailId: item.emailId }, index)"
            >
              发件箱
              <!-- <font v-if="item.toUnreadCount != '-1' && item.toUnreadCount != '0'" color="red"
                >（{{ item.toUnreadCount }}）</font
              > -->
              <el-tooltip class="item" effect="dark" content="发送失败" placement="top-start">
                <i class="circle-wraing el-icon-warning" v-if="item.toUnreadCount == '-1'"></i>
              </el-tooltip>
            </p>
            <p
              :class="{
                'item-activate': avtiviteItem.index == index && avtiviteItem.type == 'Drafts',
              }"
              style="cursor: pointer"
              @click="handleNodeClick({ type: 'Drafts', emailId: item.emailId }, index)"
            >
              草稿箱<font color="red"></font>
            </p>
            <p
              style="cursor: pointer"
              :class="{
                'item-activate': avtiviteItem.index == index && avtiviteItem.type == 'Collection',
              }"
              @click="handleNodeClick({ type: 'Collection', emailId: item.emailId }, index)"
            >
              重要邮件<font v-if="item.collectionUnreadCount !='0'" color="red">（{{ item.collectionUnreadCount }}）</font>
            </p>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <div v-else>
      <gj-empty></gj-empty>
    </div>
  </div>
</template>

<script>
import AddMailModal from './modal/add-mail-modal';
import { outEmailList } from '@/api/crm.js';
export default {
  name: 'mailbox-nav-bar',
  data() {
    return {
      checked: false,
      treeData: [],
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      avtiviteItem: {
        index: 0,
        type: 'From',
      },
    };
  },
  created() {
    this.getoutEmailList();
  },
  methods: {
    emailItemHandel(item, index) {
      this.treeData.splice(index, 1, { ...item, show: !item.show });
    },
    getoutEmailList(type) {
      this.loading = true;
      outEmailList()
        .then((res) => {
          this.treeData = res.data || [];
          this.treeData.forEach((item) => {
            item.show = false;
          });
          if (this.treeData.length) {
            this.treeData.splice(this.avtiviteItem.index, 1, { ...this.treeData[this.avtiviteItem.index], show: true });
            this.handleNodeClick(
              {
                emailId: this.treeData[this.avtiviteItem.index].emailId,
                type: this.avtiviteItem.type,
              },
              this.avtiviteItem.index,
              type,
            );
          }
        })
        .complete(() => (this.loading = false));
    },
    handleNodeClick(data, index, type) {
      this.avtiviteItem.type = data.type;
      this.avtiviteItem.index = index;
      this.$emit('treeItemClick', data, type);
    },
    openTemplateModal() {
      const vm = this;
      const modal = this.$gjCreate(AddMailModal, {
        on: {
          after() {
            vm.getoutEmailList();
            modal.$gjDestroy();
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.reply-mailbox-nav-bar {
  display: flex;
  flex-direction: column;
  background: #f6f8fb;
  width: 156px;
  height: 100%;
  padding: 12px 0;
  box-sizing: border-box;
  border-right: 1px solid #e4e5e6;
  .item-activate {
    background: #eef3fb !important;
    color: rgba(31, 110, 239, 1) !important;
  }
  .item-box {
    p {
      padding-left: 30px !important;
    }
  }
  .triangle {
    color: rgba(205, 205, 205, 1);
    font-size: 14px;
    top: -5px;
    position: relative;
  }
  .triangle-activate {
    transform: rotate(90deg);
  }
  .nav-email-box {
    flex: 1;
    overflow: overlay;
    p {
      margin: 0;
      padding: 7px 0;
    }
  }
  .circle-wraing {
    color: red;
    position: relative;
    top: 1px;
    font-size: 12px;
  }
  .switch-cell {
    width: 132px;
    height: 26px;
    margin: 8px auto;
    position: relative;
    text-align: center;
    line-height: 26px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d8dadd;
    cursor: pointer;
    color: #666;
    z-index: 2;
    color: #1f6eef;
    border: 1px solid #1f6eef;
    border-radius: 4px;
  }
  .switch-cell:hover{
     background: #edf7ff;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #eef3fb !important;
  }
  /deep/ .el-tree {
    background: #f6f8fb !important;
  }
}
.title-box {
  display: flex;
  flex-direction: row;
  padding: 0 12px;
  justify-content: space-between;
  p {
    font-size: 12px;
    margin: 0;
  }
  .title {
    text-align: left;
    font-size: 12px;

    color: rgba(51, 51, 51, 1);
    font-weight: 600;
  }
  .set {
    text-align: right;
    cursor: pointer;
    color: rgba(102, 102, 102, 1);
    font-weight: 600;
  }
}
</style>
